import React from "react"
import {connect} from "react-redux"
import {Body} from "../components/Body"
import {Firebase} from "../components/Firebase"
import {Link} from "../components/Link"

class Home extends React.Component {
  componentDidMount() {
    this.firebase = new Firebase()
  }

  render() {
    return (
      <Body>
        <ul>
          <li>
            <Link to="cost-projection">Cost Projection</Link>
          </li>
          <li>
            <Link to="google-trips/home/1">Google Trips</Link>
          </li>
          <li>
            <Link to="share-tax">ShareTax</Link>
          </li>
          <li>
            <Link to="portal">Portal</Link>
          </li>
        </ul>
      </Body>
    )
  }
}

export default connect((state) => ({}), {})(Home)
